import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApiParserService {
  public static parseDate(
    date: Date | string | null | undefined
  ): string | null | undefined {
    if (!date) {
      return date;
    }

    if (typeof date === 'string') {
      date = new Date(date);
    }

    return ApiParserService.dateToString(date);
  }

  public static parseParams(params: any) {
    const clonedParams: any = { ...params };

    for (const key in clonedParams) {
      if (!clonedParams[key]) {
        delete clonedParams[key];
      }
    }

    return clonedParams;
  }

  public static parseFromDate(date: Date | string | undefined | null) {
    if (!date) {
      return date;
    }

    if (typeof date === 'string') {
      date = new Date(date);
    }

    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);

    return this.dateToString(date);
  }

  public static parseToDate(date: Date | string | undefined | null) {
    if (!date) {
      return date;
    }

    if (typeof date === 'string') {
      date = new Date(date);
    }

    date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);

    return this.dateToString(date);
  }

  private static dateToString(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
